import { CURRENCIES } from '@/constants/currencies'

/**
 * Formats a number as currency with the correct symbol based on currency code or symbol
 * @param value The number to format as currency
 * @param currency The currency code (e.g. "USD", "EUR") or symbol (e.g. "$") to use (default: $)
 * @param round Whether to round the value (true) or not (false)
 * @returns Formatted currency string
 */
export function formatCurrency(
    value: number,
    currency: string = '$',
    round: boolean
): string {
    // Try to find the symbol if a currency code is provided
    let symbol = currency
    if (currency.length === 3) {
        const found = CURRENCIES.find(
            (c) => c.code.toUpperCase() === currency.toUpperCase()
        )
        if (found) {
            symbol = found.symbol
        }
    }

    if (!value && value !== 0) return `${symbol}0`

    // Round value if needed
    const finalValue = round ? Math.round(value) : value

    // Format with comma separators and decimal places
    const formatted = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: round ? 0 : 0,
        maximumFractionDigits: round ? 0 : 2,
    }).format(finalValue)

    return `${symbol}${formatted}`
}
